import React from 'react';
import {
  Box,
  Container,
  Typography
  // Button,
  // Checkbox,
  // FormControlLabel,
  // Link
} from '@mui/material';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import getStyles from './styles';
// import { useNavigate } from 'react-router-dom';

const MVPReady = () => {
  const styles = getStyles();
  // const navigate = useNavigate();
  // const [agreed, setAgreed] = useState(false);

  // const handleStartProject = () => {
  //   navigate('/contact');
  // };

  return (
    <Box component="section" sx={styles.section}>
      {/* Animated background overlay */}
      <Box sx={styles.animatedBackground} />
      <Container maxWidth="xl" sx={styles.container}>
        <Box sx={styles.contentWrapper}>
          {/* Heading */}
          <Typography variant="h2" sx={styles.title}>
            Ready to Launch Your Website in 2 Days?
          </Typography>
          <Typography variant="h5" sx={styles.subtitle}>
            Joined list of clients who trusted us with their online presence
          </Typography>
          {/* Card */}
          {/* <Box sx={styles.card}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  sx={styles.checkbox}
                />
              }
              label={
                <Typography variant="body2" sx={styles.termsLabel}>
                  I confirm I have read and agree to the{' '}
                  <Link href="#terms" underline="hover" sx={styles.termsLink}>
                    2-Day Website Launch Terms & Conditions
                  </Link>
                </Typography>
              }
            />
            <Button
              variant="contained"
              color="secondary"
              size="large"
              fullWidth
              disabled={!agreed}
              endIcon={<ArrowForwardIcon sx={styles.arrowIcon} />}
              sx={styles.ctaButton}
              onClick={() => handleStartProject()}
            >
              Start My 2-Day Website Launch
            </Button>
            <Typography variant="caption" sx={styles.securityNote}>
              🔒 Secure checkout • 💯 Money-back guarantee • ⚡ 48-hour delivery
            </Typography>
          </Box> */}
        </Box>
      </Container>
    </Box>
  );
};

export default MVPReady;
